const Header = ((($) => {

  let $window;
  let header;
  let headerTop;
  let headerMobileTop;

  function init() {
    $window = $(window);
    header = $('.Header__menu');
    headerTop = $('.Header__menu').offset();
    headerMobileTop = $('.mobile-nav').offset();

    _attachEvents();
  }

  function _attachEvents() {
    $window.scroll(_handleWindowScroll);
  }

  function _handleWindowScroll() {
    const scrollTop = $window.scrollTop();
    if (scrollTop >= headerTop.top) {
      header.addClass('fixed');
    }
    else {
      header.removeClass('fixed');
    }
    if($(window).width() <= 768) {
      if (scrollTop >= headerMobileTop.top) {
        $('.mobile-nav').addClass('fixed');
      }
      else {
        $('.mobile-nav').removeClass('fixed');
      }
    }
  }

  return {
    init,
  };

}))(jQuery);

export default Header;



// WEBPACK FOOTER //
// ./src/static/js/modules/header.js